export enum NumberTypeEnum {
    Delivery = 'Delivery',
    PurchaseOrder = 'PurchaseOrder',
    SalesOrder = 'SalesOrder',
    HandlingUnit = 'HandlingUnit',
    TransportUnit = 'TransportUnit'
}
